import { getSessionAuthentication, rms2BasePath } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface ArticleType {
    id: number;
    articleTypeName: string;
    articleSystemType?: string;
    name?: string;
}

export async function getArticleType(id: number): Promise<ArticleType> {
    return rms2Fetch<ArticleType>(`articletypes/${id}`);
}

export async function saveArticleType(articleType: ArticleType): Promise<ArticleType> {
    return rms2Fetch<ArticleType>(`articletypes/${articleType.id}`, {
        method: 'PUT',
        body: JSON.stringify({ articleTypeName: articleType.articleTypeName }),
    });
}
